import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './FarecardLock.css';
import { Farecard } from '../../services/types/apitypes';

type FarecardLockProps = {
  goBack: () => void;
  lock: (f: Farecard) => void;
  card: Farecard;
};

export default function FarecardLock({
  goBack,
  card,
  lock,
}: FarecardLockProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="ion-text-center">
        <IonIcon
          className="farcards-lock-circle"
          src="assets/icon/card-lock-circle.svg"
        ></IonIcon>
      </div>

      <h1 className="h1 pt-2 ion-text-center">{t('farecards.lock')}</h1>
      <p className="pt-1 instructions ion-text-center">
        {t('farecards.lockinstruction')}
      </p>

      <div className="pt-5 ion-text-center">
        <IonButton
          className="btn-default "
          expand="block"
          onClick={() => lock(card)}
        >
          {t('farecards.lock')}
        </IonButton>
      </div>
      <div className="ion-text-center">
        <IonButton
          onClick={goBack}
          fill="outline"
          expand="block"
          className="btn-default"
        >
          {t('home.cancel')}
        </IonButton>
      </div>

      <p className="pt-2 pb-1 instructions ion-text-center">
          <small>{t('farecards.lockinstruction2')}</small>
      </p>
    </>
  );
}
